import React from 'react'
import { FC, useState } from 'react'
import { styled } from 'styled-components'
import { Text } from './text/textStyles'
import ChevronDownSvg from '@tuhi/components/assets/icons/buttons/chevronDownMedium.svg'
import ChevronUpSvg from '@tuhi/components/assets/icons/buttons/chevronUpMedium.svg'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-top: ${(p) => `1px solid ${p.theme.colors.tertiary.tertiary200}`};
    padding-top: 16px;
    padding-bottom: 16px;
    gap: 32px;
`

const Header = styled.button`
    display: flex;
    flex-direction: row;
    width: 100%;
    text-align: left;
    padding: 0px;
    background: none;
    border: none;

    gap: 16px;
    justify-content: space-between;
`

export type AccordionProps = {
    list: AccordionContentProps[]
    className?: string
}

export type AccordionContentProps = {
    title: string
    content?: string
    children?: React.ReactNode
}

export const Accordion: FC<AccordionProps> = ({ list, className }) => {
    return (
        <Container className={className}>
            {list.map((item, index) => {
                return <AccordionItem key={index} {...item} />
            })}
        </Container>
    )
}

const AccordionItem: FC<AccordionContentProps> = ({
    title,
    content,
    children,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleAccordion = () => setIsOpen(!isOpen)

    return (
        <ItemContainer>
            <Header onClick={toggleAccordion}>
                <Text
                    size="medium"
                    $weight="semiBold"
                    color={isOpen ? 'brand' : 'primary'}
                >
                    {title}
                </Text>
                {isOpen ? <ChevronUpSvg /> : <ChevronDownSvg />}
            </Header>

            {isOpen &&
                (children ?? (
                    <Text size="medium" $weight="regular">
                        {content}
                    </Text>
                ))}
        </ItemContainer>
    )
}
